/* tslint:disable */
/* eslint-disable */
export enum ServiceaftaleStateEnum {
  None = 'None',
  CreatedPending = 'CreatedPending',
  Active = 'Active',
  ActivePendingTermination = 'ActivePendingTermination',
  Terminated = 'Terminated'
}
